export default __webpack_public_path__ + "static/media/hiltonFarmsMobile.1291346e.jpg";